import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useNavigate } from 'react-router-dom';

const EmptyState = ({ filterActive }) => {
  const navigate = useNavigate();

  return (
    <div className="empty-state flex flex-col items-center justify-center py-12 md:py-16 lg:py-20 px-4">
      <div className="w-20 h-20 md:w-24 md:h-24 lg:w-32 lg:h-32 rounded-sm bg-primary/10 border-2 border-primary/30 flex items-center justify-center mb-4 md:mb-6 shadow-glow-cyan-sm">
        <Icon name="Gem" size={48} color="var(--color-primary)" className="opacity-50" />
      </div>
      
      <h3 className="font-heading font-bold text-xl md:text-2xl lg:text-3xl text-primary mb-2 md:mb-3 text-center">
        {filterActive ? 'No Gems Found' : 'No Gems Yet'}
      </h3>
      
      <p className="text-sm md:text-base text-muted-foreground font-caption text-center max-w-md mb-6 md:mb-8">
        {filterActive 
          ? 'Try adjusting your filters to see more gems from your collection.' :'Start playing to earn your first gems. Win 2-3 hard matches against AI opponents to collect rare rewards.'}
      </p>

      {!filterActive && (
        <Button
          variant="default"
          size="lg"
          iconName="Gamepad2"
          iconPosition="left"
          onClick={() => navigate('/game-arena')}
        >
          Start Playing
        </Button>
      )}
    </div>
  );
};

export default EmptyState;